import React from 'react'
import AddIcon from '@material-ui/icons/Add'

import MetricRow from './MetricRow'
import './types'
import StyledIconButton from '../Form/StyledIconButton'

/**
 * The UI for editing metrics.
 * @param {MetricsEditProps} props
 */
const MetricsEdit = props => {
  var {
    metrics = [],
    onMetricUpdate = function() {},
    onMetricDelete = function() {},
    onMetricAdd = function() {},
    onPrimaryIndexChange = function() {},
    primaryIndex,
  } = props

  // Utility funciton for handling a metric prop change
  var onMetricPropChange = (index, propName, value) => {
    onMetricUpdate(index, {
      ...metrics[index],
      [propName]: value,
    })
  }

  var onNameChange = (index, value) => onMetricPropChange(index, 'name', value)

  var onTargetConversionRateChange = (index, value) =>
    onMetricPropChange(index, 'targetConversionRate', value)

  var onTargetCostPerMetricChange = (index, value) =>
    onMetricPropChange(index, 'targetCostPerMetric', value)

  return (
    <div>
      {metrics.map((m, i) => (
        <MetricRow
          {...m}
          onNameChange={onNameChange.bind(this, i)}
          onTargetConversionRateChange={onTargetConversionRateChange.bind(
            this,
            i,
          )}
          onTargetCostPerMetricChange={onTargetCostPerMetricChange.bind(
            this,
            i,
          )}
          isPrimary={i == primaryIndex}
          onPrimaryMetricToggle={onPrimaryIndexChange.bind(this, i)}
          onDelete={onMetricDelete.bind(this, i)}
        />
      ))}
      <StyledIconButton
        className="button-add-with-label"
        label="Add Metric"
        onClick={onMetricAdd}
      >
        <AddIcon />
      </StyledIconButton>
    </div>
  )
}

export default MetricsEdit



// WEBPACK FOOTER //
// ./src/Components/MetricsEdit/index.js